import React from 'react';
import '../styles/Hero.css';

const Hero = () => {
  // Sample data for cards (You can modify these as needed)
  const cardsData = [
    {
      title: 'High Quality Products',
      description: 'Our products are built to last with premium materials.',
      icon: 'https://img.icons8.com/?size=100&id=103936&format=png&color=000000'
    },
    {
      title: 'Innovative Solutions',
      description: 'Cutting-edge technology to solve your problems.',
      icon: 'https://img.icons8.com/?size=100&id=IPKGtum1B5Kn&format=png&color=000000',
    },
    {
      title: 'Customer Satisfaction',
      description: 'We prioritize customer happiness above all.',
      icon: 'https://img.icons8.com/?size=100&id=jyLYftQheElm&format=png&color=000000',
    },
    {
      title: 'Global Reach',
      description: 'Serving clients all around the world.',
      icon: 'https://img.icons8.com/?size=100&id=XsvEZR0h6fav&format=png&color=000000',
    },
  ];

  return (
    <section className="hero" id="home">
      {/* Hero Section */}
      <div className="hero-content">
        <h1>SUJAY INDUSTRIES</h1>
        <p>Discover amazing products and services.</p>
      </div>

      <h1 className='heading'>OUR STRENGTHS</h1>

      {/* Cards Section */}
      <div className="cards-section">
        
        {cardsData.map((card, index) => (
          <div key={index} className="card">
            <img src={card.icon} alt={card.title} className="card-icon" />
            <h3>{card.title}</h3>
            <p>{card.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Hero;
